import NewJob from './new-job';
import TimesheetIssue from './timesheet-issue'
import JobDateChange from './job-date-change'
import { Notification } from '../../types/Notification';

export interface NotificationComponentProps {
  notification: Notification;
  registerRefetch?: (refetchFn: () => void) => () => void;
}

const notificationComponents = {
  NewJob,
  TimesheetIssue,
  JobDateChange
};

export default notificationComponents;
export type NotificationComponents = typeof notificationComponents;
